import * as ACTION from '@Bootstraps/bootstrapActions';
import * as COMPONENT from '@Components';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { ClothesContext } from '@Pages/Clothes/context';
import '@Styles/clothes.css';

const Clothes = () => {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(0);
  const [limit, setLimit] = useState(6);
  const [clothes, setClothes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [searchInput, setSearchInput] = useState('');

  const { cart, clothesInquiryResponse } = useSelector(state => state);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    dispatch(ACTION.clothesInquiry());
  }, [dispatch]);

  useEffect(() => {
    if (clothesInquiryResponse) {
      setIsLoading(false);
      const { data } = clothesInquiryResponse;

      if (params.category) {
        setClothes(data.filter(e => e.category === params.category));
        setRows(Math.ceil(data.filter(e => e.category === params.category).length / limit));
      } else {
        setClothes(data);
        setRows(Math.ceil(data.length / limit));
      }

      setClothes(cloth => cloth.slice(page * limit, (page + 1) * limit));

      if (searchInput) {
        const filteredData = data.filter((item) => {
          return Object.values(item)
            .join(' ')
            .toLowerCase()
            .includes(searchInput.toLowerCase());
        });

        setPage(0);
        setClothes(filteredData.slice(page * limit, (page + 1) * limit));
        setRows(Math.ceil(filteredData.length / limit));
      }
    }
  }, [clothesInquiryResponse, page, searchInput, limit, params.category]);

  return (
    <div className='clothes container'>
      <COMPONENT.ClothesModal
        showModal={showModal}
        toggle={() => setShowModal(!showModal)}
      />

      <div className='text-center mt-5'>
        <button className='btn btn-main fw-semibold text-white py-2 px-4 rounded-0' onClick={() => setShowModal(!showModal)}>
          ADD CLOTH
        </button>
      </div>

      <COMPONENT.ClothesSearch onChange={(val) => setSearchInput(val)} />

      {isLoading ? (
        <h3 className='clothes-header text-center text-primary2 fw-bold mb-5'>
          . . .
        </h3>
      ) : !clothes.length ? (
        <h3 className='clothes-header text-center text-danger fw-bold mb-5'>
          No Cloth Available
        </h3>
      ) : (
        <div>
          <h3 className='clothes-header text-center text-dark fw-bold mb-5'>
            Showing All Clothes {" "}
            {params.category
              ? `By ${params.category}`
              : searchInput
              ? `with ${searchInput}`
              : ''}
          </h3>
          <div className='row justify-content-md-evenly gap-lg-5 justify-content-center mt-4'>
            {clothes.map((cloth) => {
              return (
                <div className='col-lg-3 col-md-5 col-10 my-md-5 my-4' key={cloth._id}>
                  <COMPONENT.ClothesItem
                    id={cloth._id}
                    favorite={cart.some(item => item._id === cloth._id)}
                    image={cloth.thumbnail}
                    title={cloth.name}
                    slug={cloth.slug}
                    desc={cloth.description.section1}
                    price={cloth.price.toString()}
                    onClick={() =>
                      navigate(`/clothes/${cloth.slug}`)
                    }
                  />
                </div>
              );
            })}
          </div>
          <ClothesContext.Provider value={{ rows, page, setPage }}>
            <COMPONENT.ClothesPagination />
          </ClothesContext.Provider>
        </div>
      )}
    </div>
  );
};

export default Clothes;
